<div class="project-modal">
  <header class="project-modal-header">
    <h2>{{ 'popins.delete.title' | translate }}</h2>
    <p>{{ 'popins.delete.info' | translate }}</p>
  </header>

  <div class="project-modal-actions">
    <ng-casto-button
      class="secondary"
      (click)="cancel()"
      [label]="'generic.no' | translate"
      [hidden]="isLoading"></ng-casto-button>
    <ng-casto-button
      class="primary"
      (click)="confirm()"
      [label]="'generic.yes' | translate"
      [loading]="isLoading"></ng-casto-button>
  </div>
</div>
